import { render } from "./DhLabel.vue?vue&type=template&id=5a18efea"
import script from "./DhLabel.vue?vue&type=script&lang=ts"
export * from "./DhLabel.vue?vue&type=script&lang=ts"
script.render = render

export default script